<div class="row m-0" [formGroup]="form">
  <div class="col-12 col-lg-6 pr-0 pr-lg-5">

    <div class="form-group">
      <label>Nome</label>
      <input class="mb-2 form-control" type="text" (input)="apenasLetras($event)" placeholder="Nome Completo" formControlName="nome">
    </div>

    <div class="form-group">
      <label>Nome Social (Opcional)</label>
      <input class="mb-2 form-control" type="text" (input)="apenasLetras($event)" placeholder="Nome Social" formControlName="nomeSocial">
      <small class="form-text text-muted">Nome que respeita a identidade de gênero da pessoa e pelo qual ela é identificada, diferindo do nome de registro. Preenchimento não obrigatório.</small>
    </div>


    <div class="form-group">
      <label>RG</label>
      <input class="mb-2 form-control" type="text" (input)="apenasNumeros($event)" placeholder="Somente números" formControlName="rg">
    </div>

    <div class="form-group">
      <label>Data de Expedição</label>
      <input class="mb-2 form-control" type="text"  mask="00/00/0000 " placeholder="" formControlName="dtaExpedicao">
    </div>

    <div class="form-group">
      <label>Órgão Expedidor</label>
      <input class="mb-2 form-control" type="text" placeholder="" formControlName="orgExpeditor">
    </div>

    <div class="form-group">
      <label>Ocupação</label>
      <input class="mb-2 form-control" type="text" (input)="apenasLetras($event)" placeholder="" formControlName="ocupacao">
    </div>

    <div class="form-group">
      <label>Sexo</label>
      <select name="codSexo" class="form-control" formControlName="codSexo">
        <option value="">--SELECIONE--</option>
        @for (item of sexos; track item; let index = $index) {
          <option [value]="item.COD_SEXO">
            {{item.DCR_SEXO}}
          </option>
        }
      </select>
    </div>

    <div class="form-group">
      <label>Data de Nascimento</label>
      <input class="mb-2 form-control" type="text" placeholder="" disabled formControlName="dtaNasc">
    </div>

    <div class="form-group">
      <label>Nome da Mãe</label>
      <input class="mb-2 form-control" type="text" placeholder="" formControlName="nomeMae">
    </div>

    <div class="form-group">
      <label>Nome do Pai</label>
      <input class="mb-2 form-control" type="text" placeholder="" formControlName="nomePai">
    </div>

    <div class="form-group">
      <label>Naturalidade</label>
      <input class="mb-2 form-control" type="text" placeholder="" formControlName="naturalidade">
    </div>
  </div>
  <div class="col-12 col-lg-6 pl-0 pl-lg-5">

    <div class="form-group">
      <label>Estado Civil</label>
      <select class="mb-2 form-control" formControlName="estadoCivil" (change)="onChangeEstadoCivil($event.target.value)">
        <option  value=null>Selecione</option>
        @for (item of listaEstadoCivil; track item) {
          <option [value]="item.COD_ESTADO_CIVIL">{{item.DCR_ESTADO_CIVIL}}</option>
        }
      </select>
    </div>

    <div class="form-group">
      <label>Nome Cônjuge</label>
      <input class="mb-2 form-control" type="text" (input)="apenasLetras($event)" placeholder="" formControlName="nomeConjuge">
      @if (nomeConjuge && form.get('nomeConjuge').value=='') {
        <div class="text-danger">
          Informe o nome do cônjuge
        </div>
      }
    </div>

    <div class="input-group mt-5 w-50">
      <input type="password" class="form-control" placeholder="Assinatura Eletrônica" formControlName="assinatura">
      <div class="input-group-append">
        <button class="btn btn-success" type="button" (click)="alterar()" [disabled]="!form.valid || loading">
          Salvar
          @if (loading) {
            <i class="fas fa-spinner fa-spin"></i>
          }
        </button>
      </div>
    </div>

    @if (msgErro!=null) {
      <div class="msgErroForm">
        {{msgErro}}
      </div>
    }

  </div>
</div>

